import styled, { css } from 'styled-components'
import { Spinner } from 'src/components/common/Spinner'
import { Container } from 'src/components/common/Container'
import {
  AlwaysDiscountCouponPageProps,
  AlwaysPageCouponSortOrderType,
} from 'src/pages/AlwaysDiscounCouponPage/index'
import AlwaysDiscountChipsList from 'src/pages/AlwaysDiscounCouponPage/_components/AlwaysDiscountChipsList'

import RenderIf from 'src/components/common/RenderIf'
import always_top_banner from 'src/assets/images/always/always_top_banner.png'
import React from 'react'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16, Noto_body3_m12, Noto_body3_r12 } from 'src/styles/fonts/NotoSansKrFonts'
import { AlwaysDiscountCouponListSpace } from 'src/types/api'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import LazyImage from 'src/components/common/LazyImage'
import { Roboto_num2_b16 } from 'src/styles/fonts/RobotoFonts'
import { getBrandAndCouponName } from 'src/utils'
import Skeleton from 'react-loading-skeleton'
import CustomSelect from 'src/components/common/CustomSelect'

const AlwaysDiscountCouponPageView = (props: AlwaysDiscountCouponPageProps) => {
  const {
    alwaysProductsNoMore,
    alwaysCouponDetailPageNav,
    setTarget,
    isAlwaysQueryCouponListSuccess,
    alwaysCategory,
    alwaysCouponListData,
    selectListItems,
    couponSortOrder,
    alwaysCouponSortHandler,
  } = props
  const isEmptyAlwaysCouponItems = alwaysCouponListData?.length === 0
  const [, setPrevAlwaysCategory] = useLocalStorage<number>(
    'prev_always_category',
    Number(alwaysCategory),
  )

  return (
    <S.AlwaysDiscount.Container $option="flex_column">
      <S.AlwaysDiscount.Contents $option="flex_row_space_between">
        <S.AlwaysDiscount.PrimaryImg src={always_top_banner} alt="top banner" />
      </S.AlwaysDiscount.Contents>
      <AlwaysDiscountChipsList {...props} />
      {isAlwaysQueryCouponListSuccess && isEmptyAlwaysCouponItems ? (
        <S.AlwaysDiscount.EmptyCouponLists $option="flex_column">
          <Typography $fontStyle={Noto_body1_r16} $color="var(--black-30)">
            진행중인 상품이 없습니다.
          </Typography>
        </S.AlwaysDiscount.EmptyCouponLists>
      ) : (
        <S.AlwaysDiscount.CouponContainer $option="flex_column">
          <S.AlwaysDiscount.SelectContainer $option="flex_row">
            <CustomSelect<AlwaysPageCouponSortOrderType>
              listItems={selectListItems}
              currentValue={couponSortOrder}
              selectOnchangeHandler={alwaysCouponSortHandler}
              customSelectWrapStyle={S.AlwaysDiscount.SelectWrap}
              defaultSelectWrapStyle={S.AlwaysDiscount.ClosedSelectStyle}
              activeSelectWrapStyle={S.AlwaysDiscount.ActiveSelectWrapStyle}
              openSelectWrapStyle={S.AlwaysDiscount.OpenSelectWrapStyle}
              openSelectItemsStyle={S.AlwaysDiscount.OpenSelectItemsStyle}
            />
          </S.AlwaysDiscount.SelectContainer>
          <S.CouponCard.List>
            {alwaysCouponListData?.map(
              (ele: AlwaysDiscountCouponListSpace.CommonCouponType, index: number) => {
                const {
                  CouponImage,
                  CouponNumber,
                  CouponIdx,
                  CouponName,
                  DiscountRate,
                  SalePrice,
                } = ele
                const handleCardClick = () => {
                  setPrevAlwaysCategory(Number(alwaysCategory))
                  alwaysCouponDetailPageNav(CouponNumber, CouponIdx)
                }
                return (
                  <S.CouponCard.Items
                    key={index}
                    $option="flex_column"
                    $row_gap="8px"
                    onClick={handleCardClick}
                  >
                    <S.CouponCard.ImageWrap>
                      <LazyImage src={CouponImage} alt="쿠폰이미지" style={S.CouponCard.Image} />
                    </S.CouponCard.ImageWrap>
                    <RenderIf when={!SalePrice}>
                      <Skeleton width="100%" count={3} style={{ marginTop: '2px' }} />
                    </RenderIf>
                    <RenderIf when={!!SalePrice}>
                      <S.CouponCard.TextContainer $option="flex_column">
                        <Container $option="flex_row" $column_gap="4px">
                          <S.CouponCard.DiscountRate
                            $fontStyle={Roboto_num2_b16}
                            $color="var(--brand-50)"
                          >
                            {Math.floor((DiscountRate as number) * 10) / 10}%
                          </S.CouponCard.DiscountRate>
                          <S.CouponCard.SalePrice
                            $fontStyle={Roboto_num2_b16}
                            $color="var(--black-90)"
                          >
                            {SalePrice?.toLocaleString()}원
                          </S.CouponCard.SalePrice>
                        </Container>
                        <S.CouponCard.CouponBrand
                          $fontStyle={Noto_body3_m12}
                          $color="var(--black-90)"
                        >
                          {getBrandAndCouponName(CouponName).brandName}
                        </S.CouponCard.CouponBrand>
                        <S.CouponCard.CouponName
                          $fontStyle={Noto_body3_r12}
                          $color="var(--black-90)"
                        >
                          {getBrandAndCouponName(CouponName).couponName}
                        </S.CouponCard.CouponName>
                      </S.CouponCard.TextContainer>
                    </RenderIf>
                  </S.CouponCard.Items>
                )
              },
            )}
          </S.CouponCard.List>
        </S.AlwaysDiscount.CouponContainer>
      )}
      <RenderIf when={!alwaysProductsNoMore && !isEmptyAlwaysCouponItems}>
        <Spinner $color="var(--black-10)" ref={setTarget} $margin="50px auto 0 auto" />
      </RenderIf>
    </S.AlwaysDiscount.Container>
  )
}

export default AlwaysDiscountCouponPageView

const S = {
  AlwaysDiscount: {
    Container: styled(Container)`
      margin: 40px auto 50px auto;
      min-height: 700px;
    `,
    Contents: styled(Container)`
      padding: 20px 20px 10px 20px;
    `,
    PrimaryImg: styled.img`
      width: 100%;
      max-width: 648px;
    `,
    EmptyCouponLists: styled(Container)`
      justify-content: center;
      text-align: center;
      padding: 100px 0;
      flex: 1;
    `,
    CouponContainer: styled(Container)`
      padding: 0 20px;
      min-height: 500px;
      height: 100%;
    `,
    SelectContainer: styled(Container)`
      justify-content: right;
      margin: 10px 0 14px 0;
    `,
    SelectWrap: css`
      width: 110px;
      display: flex;
      ${Noto_body3_r12};
    `,
    ClosedSelectStyle: css`
      display: flex;
      align-items: center;
      width: 100%;
      height: 30px;
      color: var(--black-70);
      text-align: center;
      cursor: pointer;
      gap: 10px;
      border: 1px solid var(--black-10);
      border-radius: 8px;
      padding: 6px 10px;
      justify-content: space-between;
    `,
    ActiveSelectWrapStyle: css`
      border-radius: 8px 8px 0 0;
      border-bottom: unset;
    `,
    OpenSelectWrapStyle: css`
      width: 100%;
      border-radius: 0 0 8px 8px;
      border-right: 1px solid var(--black-10);
      border-bottom: 1px solid var(--black-10);
      border-left: 1px solid var(--black-10);
      top: 30px;
      right: 0;
      z-index: 2;
    `,
    OpenSelectItemsStyle: css`
      color: var(--black-70);
      background-color: var(--white);
      padding: 6px 10px;
      &:hover,
      &:focus {
        background-color: var(--black-4);
      }
      &:nth-child(2) {
        border-radius: 0 0 8px 8px;
      }
    `,
  },
  CouponCard: {
    List: styled(Container)`
      display: grid;
      width: 100%;
      grid-template-columns: repeat(auto-fill, minmax(156px, 1fr));
      ${mediaMaxWidth('360')} {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      }
      row-gap: 30px;
      grid-column-gap: 8px;
    `,
    Items: styled(Container)`
      width: 100%;
      height: fit-content;
      cursor: pointer;
    `,
    ImageWrap: styled(Container)`
      position: relative;
      height: 0;
      padding-bottom: 100%;
    `,
    Image: css`
      position: absolute;
      top: 0;
      border-radius: 12px;
      outline: 1px solid rgba(0, 0, 0, 0.08);
      padding: 10px;
      width: 100%;
      height: 100%;
      > img {
        border-radius: inherit;
      }
    `,
    TextContainer: styled(Container)``,
    DiscountRate: styled(Typography)``,
    SalePrice: styled(Typography)``,
    CouponBrand: styled(Typography)`
      margin-top: 6px;
    `,
    CouponName: styled(Typography)`
      ${ellip('line2')};
    `,
  },
}
